"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./customerQuery"), exports);
__exportStar(require("./dealerQuery"), exports);
__exportStar(require("./employeeQuery"), exports);
__exportStar(require("./vehicle-inventory"), exports);
__exportStar(require("./vehicle-order"), exports);
__exportStar(require("./vehicle-stock"), exports);
//# sourceMappingURL=index.js.map